import React from 'react';

const TodayTaskPage: React.FC = () => {
    return (
        <div>
            TodayTaskPage
        </div>
    );
};

export { TodayTaskPage }
